import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content container" }

import { useRoute } from 'vue-router';
import bannerBread from '@/components/web/bannerBread.vue';
import headText from '@/components/web/headText.vue';
import benefitsCasting from '@/components/web/benefitsCasting.vue';
import imageTableTitle from '@/components/web/imageTableTitle.vue';
import imageAlt from '@/components/web/imageAlt.vue';
import castingServices from '@/components/web/castingServices.vue';
import { reactive, ref, onBeforeMount } from 'vue';

type pictureTextItem = {
  imgUrl: string;
  alt: string;
}

type picturetitleItem = {
  imgUrl: string;
  alt: string;
  title: string;
}


type image = {
  alt: string;
  imageUrl: string;
}
//headText
type h2pLContentItem = {
  h2Title?: string;
  h3Title?: string;
  pList: string[];
  liList?: string[];
  pOther?: string;
}
const h1Title = "Centrifugal Casting";
const h3ben = "The Features Of Centrifugal Casting ";
const pBen = ``;
const h2Text = "Different Types Production Scenario Of Centrifugal Casting"
const h2Case = "The Minghe Case Studies Of Centrifugal Casting";
const pCase = "Minghe Casting fabrication services are available for both design to reality and low to high volume production runs of your die casting parts,sand casting parts,investment casting parts,metal casting parts, lost foam casting parts and more.";
const pAHref = "Go To View More Casting Parts Cases Studies >>>";

//choose
const h2Choose = "Choose the Best Centrifugal Casting Supplier";
const h2CastingServices = "We Provide Casting Services Include:";

export default /*@__PURE__*/_defineComponent({
  __name: 'Container',
  setup(__props) {

const route = useRoute();

const bannerImages = ref<pictureTextItem[]>([]);

//离心模铸造工艺的好处集合
const centrifugalCastingProcessBenefitsCollection = reactive<string[]>([]);
//离心模铸造的不同类型生产设备集合
const centrifugalCastingMachinesCollection = reactive<picturetitleItem[]>([]);
// 离心模铸造案例集合
const centrifugalCastingExamples = reactive<pictureTextItem[]>([]);



onBeforeMount(() => {
  //数据填充函数
  populateCollections();

})

//组件传输
const h2pLContent = ref<h2pLContentItem[]>([]);


//ben
const leftImage: image = {
  alt: "Benefits of Centrifugal Casting Process",
  imageUrl: "https://www.diecastingcompany.com/uploads/2101/free-dfm-and-engineering-support.png"
}
const rightImage: image = {
  alt: "Our Centrifugal Casting Customization Process",
  imageUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting.jpg"
}

//imageTableTitle
const pText = ["Minghe always adheres to the customer's requirements and the company's service standards. In any link of mold design, mold assembly, mold debugging, mold trial production, casting process, etc., there are dedicated engineers to keep you on the phone;"];

//imageAlt
const pChoose = [`Currently, our centrifugal casting parts are exported to America, Canada, Australia, United Kingdom, Germany, France, Sout Africa, and many other countries all over the world. We are ISO9001-2015 registered and also certified by SGS.`,
  `Our custom centrifugal casting fabrication service provides durable and affordable castings that meet your specifications for automotive, medical, aerospace, electronics, food, construction, security, marine, and more industries. Fast to send your inquiry or submit your drawings to get a free quote in the shortest time.Contact us or Email sales@hmminghe.com to see how our people, equipment and tooling can bring the best quality for the best price for your centrifugal casting project.`
]

//service
const pCastingService = [`Minghe Casting services working with sand casting、metal casting 、investment casting lost foam casting, and more.`]

// 数据填充函数
const populateCollections = () => {
  bannerImages.value = [{ imgUrl: 'https://c74.hongcdn.com/uploads/2107/lost-form-casting-!j.webp', alt: 'Lost Foam Casting' },]
  h2pLContent.value = [
    {
      h2Title: "What is Centrifugal Casting", pList: [`Centrifugal Casting is a technique and method of injecting liquid metal into a high-speed rotating mold, so that the liquid metal is centrifugal motion to fill the mold and form a casting. Due to the centrifugal movement, the liquid metal can fill the mold well in the radial direction and form the free surface of the casting; the cylindrical inner hole can be obtained without the core; it is helpful to eliminate the gas and inclusions in the liquid metal; it affects the metal The crystallization process improves the mechanical and physical properties of the casting.`,
        `According to the spatial position of the rotation axis of the mold, common centrifugal casting can be divided into horizontal centrifugal casting and vertical centrifugal casting. Centrifugal casting when the rotation axis of the mold is in a horizontal state or when the angle with the horizontal line is small (4°) is called horizontal centrifugal casting. Centrifugal casting when the rotation axis of the mold is in a vertical state is called vertical centrifugal casting. Centrifugal casting in which the rotation axis of the mold has a large angle with the horizontal and vertical lines is called inclined axis centrifugal casting, but it is rarely used.`],
    },
    {
      h2Title: "The Application Field Of Centrifugal Casting", h3Title: "Castings with significant production benefits include:",
      pOther: `Centrifugal casting was first used to produce cast pipes, and then this process has been rapidly developed. At home and abroad, the centrifugal casting process is used in metallurgy, mining, transportation, irrigation and drainage machinery, aviation, national defense, automobile and other industries to produce steel, iron and non-ferrous carbon alloy castings. Among them, the production of castings such as centrifugal cast iron pipes, internal combustion engine cylinder liners and shaft sleeves is the most common. For some forming tools and gear castings, centrifugal force pouring can also be used for the molten mold shell, which can not only improve the accuracy of the casting, but also improve the mechanical properties of the casting.`,
      pList: [],
      liList: [
        "- Bimetal cast iron roll",
        "- Heat-resistant steel roller table at the bottom of the heating furnace",
        "- Special steel seamless steel pipe",
        "- Brake drum, piston ring blank, copper alloy worm wheel",
        "- Special-shaped castings such as impellers, metal dentures, gold and silver mesons, small valves and cast aluminum motor rotors"
      ]
    },
    {
      h3Title: "Castings with large production output include:",
      pOther: `Founded in 1995, China Minghe Casting is an industry standard formulation unit for pattern forming molds for centrifugal casting. Minghe is located in the world's industrial capital-Dongguan, China. It is a high-tech enterprise in Guangdong Province. It has a production workshop with a construction area of ​​18,000 square meters. It is equipped with equipment for research and development, design, casting, machining, assembly, and surface treatment. It is the Dongguan R&D center and Technology Center. Minghe Casting now has 6 invention patents and 20 utility model patents. It is a trademark enterprise in Guangdong Province. The company has more than 230 employees, including 36 mold design engineers and 39 technicians; it has 40 CNC processing equipment and general processing equipment. 28 units, 3 coordinate measuring machines, and 1 reverse scanner. Using computer three-dimensional design, programming, computer-aided processing technology, using FM method to cast aluminum mold blanks, combined with Minghe Casting created TEFLON (TEFLON) surface coating technology and subsidiary Minghe Powder Coating Factory, so that mold quality, precision, efficiency, The service life can meet the requirements of customers. The company's technical staff guide the mold assembly, use, trial production, free maintenance, and can provide a full set of centrifugal casting technology according to customer needs.`,
      pList: [],
      liList: [
        "- Iron pipe: Nearly 1/2 of the total annual output of ductile iron in the world is iron pipe produced by centrifugal casting",
        "- Cylinder liners of diesel engines and gasoline engines",
        "- Various types of steel sleeves and steel pipes",
        "- Bimetallic steel back copper sleeve, bearing bushes of various alloys",
        "- Paper machine drum"
      ]
    },
  ]

  centrifugalCastingProcessBenefitsCollection.push(
    "– There is almost no metal consumption in the gating system and the riser system, which improves the production rate of the process;",
    "– The core is not used in the production of hollow castings, so the metal filling ability can be greatly improved when producing long tubular castings, the ratio of the wall thickness of the castings to the length or diameter can be reduced, and the production process of sleeve and tube castings can be simplified;",
    "– The casting has high density, few defects such as pores and slag inclusion, and high mechanical properties;",
    "– It is convenient to manufacture barrel and sleeve composite metal castings, such as steel-backed copper sleeves, bimetallic rolls, etc.; when forming castings, centrifugal motion can be used to increase the metal filling ability, so thin-walled castings can be produced.",
    "– There are certain limitations when used in the production of special-shaped castings.",
    "– The diameter of the inner hole of the casting is not accurate, the surface of the inner hole is relatively rough, the quality is poor, and the machining allowance is large;",
    "– Castings are prone to segregation of specific gravity, so they are not suitable for castings that are prone to segregation of specific gravity (such as lead bronze), and are especially not suitable for casting alloys with impurities larger than molten metal."
  );



  centrifugalCastingMachinesCollection.push(
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-1.jpg", alt: "Centrifugal-Casting Process (1)", title: "The Scenario Of Manufacturing Centrifugal Casting1" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-2.jpg", alt: "Centrifugal-Casting Process (2)", title: "The Scenario Of Manufacturing Centrifugal Casting2" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-3.jpg", alt: "Centrifugal-Casting Process (3)", title: "The Scenario Of Manufacturing Centrifugal Casting3" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-4.jpg", alt: "Centrifugal-Casting Process (4)", title: "The Scenario Of Manufacturing Centrifugal Casting4" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-5.jpg", alt: "Centrifugal-Casting Process (5)", title: "The Scenario Of Manufacturing Centrifugal Casting5" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-6.jpg", alt: "Centrifugal-Casting Process (6)", title: "The Scenario Of Manufacturing Centrifugal Casting6" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-7.jpg", alt: "Centrifugal-Casting Process (7)", title: "The Scenario Of Manufacturing Centrifugal Casting7" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-8.jpg", alt: "Centrifugal-Casting Process (8)", title: "The Scenario Of Manufacturing Centrifugal Casting8" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-9.jpg", alt: "Centrifugal-Casting Process (9)", title: "The Scenario Of Manufacturing Centrifugal Casting9" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-10.jpg", alt: "Centrifugal-Casting Process (10)", title: "The Scenario Of Manufacturing Centrifugal Casting10" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-11.jpg", alt: "Centrifugal-Casting Process (11)", title: "The Scenario Of Manufacturing Centrifugal Casting11" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-process-12.jpg", alt: "Centrifugal-Casting Process (12)", title: "The Scenario Of Manufacturing Centrifugal Casting12" }
  );

  centrifugalCastingExamples.push(
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-1.jpg", alt: "Centrifugal Casting Parts 1" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-2.jpg", alt: "Centrifugal-Casting Parts (2)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-3.jpg", alt: "Centrifugal-Casting Parts (3)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-4.jpg", alt: "Centrifugal-Casting Parts (4)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-5.jpg", alt: "Centrifugal-Casting Parts (5)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-6.jpg", alt: "Centrifugal-Casting Parts (6)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-7.jpg", alt: "Centrifugal-Casting Parts (7)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-8.jpg", alt: "Centrifugal-Casting Parts (8)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-9.jpg", alt: "Centrifugal-Casting Parts (9)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-10.jpg", alt: "Centrifugal-Casting Parts (10)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-11.jpg", alt: "Centrifugal-Casting Parts (11)" },
    { imgUrl: "https://www.diecastingcompany.com/uploads/2107/centrifugal-casting-parts-12.jpg", alt: "Centrifugal-Casting Parts (12)" }
  );





};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "header-banner", {}, () => [
      _createVNode(bannerBread, { "banner-images": bannerImages.value }, null, 8, ["banner-images"])
    ], true),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "content", {}, () => [
        _createVNode(headText, {
          "h1-title": h1Title,
          "h2p-l-content": h2pLContent.value
        }, null, 8, ["h2p-l-content"]),
        _createVNode(benefitsCasting, {
          BenefitsCollection: centrifugalCastingProcessBenefitsCollection,
          "h3-title": h3ben,
          pTitle: pBen,
          leftImage: leftImage,
          rightImage: rightImage
        }, null, 8, ["BenefitsCollection"]),
        _createVNode(imageTableTitle, {
          wrap: true,
          "has-arrow": true,
          h2Title: h2Text,
          pTitle: pText,
          ImageTitleCollection: centrifugalCastingMachinesCollection,
          "table-image": false,
          span: 6,
          center: true,
          strong: true
        }, null, 8, ["ImageTitleCollection"]),
        _createVNode(imageAlt, {
          imageAltCollection: centrifugalCastingExamples,
          "h2-title": h2Case,
          "p-t": pCase,
          span: 6,
          "p-a-href": pAHref
        }, null, 8, ["imageAltCollection"]),
        _createVNode(headText, {
          "h2-title": h2Choose,
          "p-list": pChoose
        }),
        _createVNode(castingServices, {
          "h2-title": h2CastingServices,
          "p-title": pCastingService
        })
      ], true)
    ])
  ]))
}
}

})